export default "__VITE_ASSET__CTmyPeij__"